export default "__VITE_ASSET__BAwa12rF__"